// DMS channel (as supplied by ODS) to Admin Portal channel / organization.
//
// Admin Portal Channel | Organization | DMS Channel Code | DMS Channel Name
// ---------------------+--------------+------------------+--------------------------
// HSBC Life            | Agency       | AG               | Tied Agency
// HSBC Life            | CAS          | WS               | Client Advisory Services
// HSBC Life            | SingPost     | PO               | PostAssurance
// HSBC Life            | IAM          | FS               | Fusion
// Broker               | (*)          | IB               | International Broker
// Banca                | (*)          | BH               | Bancassurance
// FA                   | (*)          | BF               | FA
//
// (*) personal.name of the levelCode 02 node, see resolveLevelOrganization.
const HSBC_LIFE = 'HSBC Life';
const DMS_CHANNELS = [
  { code: 'AG', name: 'Tied Agency', channel: HSBC_LIFE, organization: 'Agency' },
  { code: 'WS', name: 'Client Advisory Services', channel: HSBC_LIFE, organization: 'CAS' },
  { code: 'PO', name: 'PostAssurance', channel: HSBC_LIFE, organization: 'SingPost' },
  { code: 'FS', name: 'Fusion', channel: HSBC_LIFE, organization: 'IAM' },
  { code: 'IB', name: 'International Broker', channel: 'Broker', organization: '' },
  { code: 'BH', name: 'Bancassurance', channel: 'Banca', organization: '' },
  { code: 'BF', name: 'FA', channel: 'FA', organization: '' },
];

const equalsIgnoreCase = (left, right) =>
  typeof left === 'string' && left.trim().toLowerCase() === String(right).toLowerCase();

const resolveDmsChannel = (channelCode, channelName) => {
  for (let i = 0; i < DMS_CHANNELS.length; i += 1) {
    if (equalsIgnoreCase(channelCode, DMS_CHANNELS[i].code)) return DMS_CHANNELS[i];
  }
  for (let i = 0; i < DMS_CHANNELS.length; i += 1) {
    if (equalsIgnoreCase(channelName, DMS_CHANNELS[i].name)) return DMS_CHANNELS[i];
  }
  return null;
};

// IB / BH / BF: organization is personal.name of the levelCode 02 node, i.e. the agent
// itself or its nearest primary manager at that level.
const resolveLevelOrganization = (agent) => {
  let node = agent;
  while (node) {
    if ('02' === String(node.basic?.levelCode || '').trim()) return node.personal?.name || '';
    node = node.managers?.primary?.manager;
  }
  return '';
};

export const toAgentList = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response?.agents)) return response.agents;
  return [];
};

export const selectAgent = (agents) => {
  if (!Array.isArray(agents) || 0 === agents.length) return null;
  for (let i = 0; i < agents.length; i += 1) {
    const isActive = agents[i]?.statuses?.isActive;
    if (true === isActive || 'true' === isActive) return agents[i];
  }
  return agents[0];
};

const toAgentProduct = (serveProduct) => {
  if (!Array.isArray(serveProduct)) return [];
  const products = [];
  for (let i = 0; i < serveProduct.length; i += 1) {
    const product = serveProduct[i];
    if (product && String(product).trim()) products.push(String(product).trim());
  }
  return products;
};

export const mapOdsAgentToUserProfile = (agent) => {
  const basic = agent?.basic || {};
  const personal = agent?.personal || {};
  const business = agent?.business || {};
  const dmsChannel = resolveDmsChannel(business.channelCode, business.name);
  const agentUniqueID = parseInt(String(basic.identifier || '').trim(), 10);

  const profile = {
    agentBasicInfo: {
      agentUniqueID: isNaN(agentUniqueID) ? null : agentUniqueID,
      userName: personal.name,
      firstName: personal.name,
      prefix: personal.salutation,
    },
    agentBusinessInfo: {
      jobTitle: basic.title,
      lifeAgentNumber: basic.l400AgentCode,
      jadeAgentNumber: basic.j400AgentCode,
      channel: dmsChannel ? dmsChannel.channel : '',
      organizationName: dmsChannel ? dmsChannel.organization || resolveLevelOrganization(agent) : '',
      businessUnit: business.unitCode,
    },
    agentProduct: toAgentProduct(basic.serveProduct),
  };

  if (personal.email) {
    profile.emailAddresses = [{ email: personal.email }];
  }
  if (personal.mobile) {
    profile.mobileTelephoneNumbers = [
      { telephoneNumber: personal.mobile, formattedTelephoneNumber: personal.mobile },
    ];
  }
  return profile;
};
